import {useDispatch, useSelector} from "react-redux";
import {Link, useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {Dropdown} from "primereact/dropdown";
import NavFilter from "../components/NavFilter";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import CalendarHelper from "../helpers/calendar";
import Formatter from "../helpers/formater";
import Loader from "../components/Loader";
import {Message} from "primereact/message";
import {AttendanceService} from "../services/AttendanceService";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {DepartmentService} from "../services/DepartmentService";
import {FinanceService} from "../services/FinanceService";
import formater from "../helpers/formater";
import {Image} from "primereact/image";
import {ScrollPanel} from "primereact/scrollpanel";
import {Badge} from "primereact/badge";
import {Sidebar} from "primereact/sidebar";
import {Dialog} from "primereact/dialog";
import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {InputNumber} from "primereact/inputnumber";
import {InputTextarea} from "primereact/inputtextarea";
import {useFormik} from "formik";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {Tooltip} from "primereact/tooltip"

export default function Finance() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [groups, setGroups] = useState([])
    const [activeGroup, setActiveGroup] = useState()
    const [activeAdditional, setActiveAdditional] = useState()
    const [navOptions, setNavOptions] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [month, setMonth] = useState(new Date().getMonth() + 1)
    const [year, setYear] = useState(new Date().getFullYear())
    const [date, setDate] = useState(new Date())
    const [dates, setDates] = useState([])
    const [rows, setRows] = useState({children: [], receipts: []})
    const [dialogVisible, setDialogVisible] = useState(false)
    const [dialogTitle, setDialogTitle] = useState('')
    const [dialogReceipts, setDialogReceipts] = useState([])
    const [dialogChildren, setDialogChildren] = useState([])
    const [dialogDate, setDialogDate] = useState(false)
    const [dialogLoading, setDialogLoading] = useState(false)

    const [receiptDialogVisible, setReceiptDialogVisible] = useState(false)

    const [calendarVisible, setCalendarVisible] = useState(true)
    const [summ, setSumm] = useState([])
    const [additionals, setAdditionals] = useState([])
    const calendarRef = useRef()



    function updateCounters() {
        let tabs = []
        groups.map((navItem) => {
            tabs.push({
                from: dates[0].toLocaleDateString(),
                to: dates.at(-1).toLocaleDateString(),
                department_id: currentDepartment,
                type: locationParams.type,
                group_id: navItem.id
            })
        })

        if (tabs.length) {
            AttendanceService.GetCount({filters: tabs}).then((result) => {
                let copyNavOptions = JSON.parse(JSON.stringify(navOptions));

                result.map((v, k) => {
                    let g = groups.find((g) => g.id === copyNavOptions[k].query)
                    if (g) {
                        copyNavOptions[k].count = g.places ? (v + ' / ' + g.places) : v;
                    }
                })
                setNavOptions(copyNavOptions)
                setIsLoaded(true)
            })
        }
    }

    const updateData = () => {
        FinanceService.GetList({
            from: dates[0].toLocaleDateString(),
            to: dates.at(-1).toLocaleDateString(),
            department_id: currentDepartment,
            type: locationParams.type,
            group_id: activeGroup ? activeGroup : '',
            additional_id: activeAdditional ? activeAdditional : ''
        }).then((r) => {
            updateCounters()
            setRows(r)

            let summData = {}
            r.receipts.map((el) => {
                if (parseInt(el.status) === 1) {
                    summData[el.date] = el.date in summData ? (summData[el.date] + 1) : 1;
                }
            })
            setSumm(summData)

            if (['additional_class', 'individual_lesson'].includes(locationParams.type)) {
                setIsLoaded(true)
            }

            if(dialogChildren){
                if(dialogDate) {
                    setDialogReceipts(r.receipts.filter((rec) => rec.children_id === dialogChildren.id && rec.date === formater.dateWithOffset(dialogDate)))
                } else {
                    setDialogReceipts(r.receipts.filter((rec) => rec.children_id === dialogChildren.id && !rec.date))
                }
            }

        })
    }

    useEffect(() => {
        setIsLoaded(false)

        if (dates && dates.length > 0 && ((groups && groups.length && activeGroup) || activeAdditional)) {
            updateData()
        }

    }, [dates, groups, activeGroup, activeAdditional]);

    useEffect(() => {
        setMonth(date.getMonth() + 1)
        setYear(date.getFullYear())
    }, [date])


    useEffect(() => {
        let navData = []
        groups.map((el) => {
            navData.push({
                label: el.name,
                query: el.id,
                count: '0 / 0'
            })
        })
        setNavOptions(navData)
    }, [groups])

    useEffect(() => {
        // setNavOptions([])
        setActiveGroup(false)

        setRows({children: [], receipts: []})

        setActiveAdditional(false)
        dispatch(setSearchString(''))
        dispatch(setSearchHandler(false))
        dispatch(setCreateButton(false))
        dispatch(setTitle(formater.types()[locationParams.type] + ', ' + date.toLocaleDateString('ru-RU', {month: 'long'}) + ' ' + date.getFullYear()))
        DepartmentService.getGroups({'filter': {'department_id': currentDepartment}}).then((response) => {
            const groups = response.items.filter((el) => {
                return el.type === groupTypes[locationParams.type]
            })
            setGroups(groups)
            if (groups && groups.length) {
                setActiveGroup(groups[0].id)
            }

        })

        let additionalType = false
        if (locationParams.type === 'additional_class') {
            additionalType = 'additional'
        }
        if (locationParams.type === 'individual_lesson') {
            additionalType = 'individual'
        }

        if (additionalType) {
            DepartmentService.getAdditionals({
                'filter': {
                    'department_id': currentDepartment,
                    'type': additionalType
                }
            }).then((response) => {
                setAdditionals(response.items)
            })
        }

    }, [locationParams, currentDepartment]);

    useEffect(() => {

        setDates(CalendarHelper.getMonths(year))
        dispatch(setTitle(formater.types()[locationParams.type] + ', ' + date.toLocaleDateString('ru-RU', {month: 'long'}) + ' ' + date.getFullYear()))
        // updateCounters()
    }, [month, year])



    const groupTypes = {
        kindergarten: 'kindergarten_group',
        summer_camp: 'kindergarten_group',
        school: 'school'
    }

    const prevYearHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setFullYear(d.getFullYear() - 1)
        setDate(d)
    }
    const nextYearHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setFullYear(d.getFullYear() + 1)
        setDate(d)
    }

    const contractsInCurrentDateInterval = (contracts, date) => {
        let inCurrent = false
        let isStart = false
        let isFinish = false
        let isEnd = false
        let cs = []
        let end = false

        contracts.map((contract) => {
            let from = new Date(contract.date_from.split('-')[0] + '-' + contract.date_from.split('-')[1] + '-01')
            let to = new Date(contract.date_to.split('-')[0] + '-' + contract.date_to.split('-')[1] + '-01')
            let d1 = new Date(date)


            if (contract.end_date) {
                end = new Date(contract.end_date.split('-')[0] + '-' + contract.end_date.split('-')[1] + '-01')
            }


            if (d1.getTime() >= from.getTime() && d1.getTime() <= to.getTime()) {
                inCurrent = true

                if (d1.getTime() === from.getTime()) {
                    isStart = true
                }
                if (d1.getTime() === to.getTime()) {
                    isFinish = true
                }
                if (end && d1.getTime() > end.getTime() && end.getTime() <= to.getTime()) {
                    isEnd = end
                }

                if (isEnd && end && from.getTime() >= end.getTime()) {
                    isEnd = false;
                    end = false;
                }

            }


        })

        if (!inCurrent) {
            cs.push('disabled')
        }
        if (isStart) {
            cs.push('start')
        }
        if (isFinish) {
            cs.push('finish')
        }
        if (isEnd) {
            cs.push('discontinued')
        }

        return cs.join(' ')
    }

    const getClasses = (contracts, date) => {
        return contractsInCurrentDateInterval(contracts, date)
    }



    const editPaymentsHandler = (child, date) => {

        if(date) {
            let d = new Date(formater.dateWithOffset(date))
            setDialogTitle(child.fio + '<br/><small>' + formater.MonthShortName(d.getMonth()) + ' ' + d.getFullYear() + '</small>')
            setDialogReceipts(rows.receipts.filter((rec) => rec.children_id === child.id && rec.date === formater.dateWithOffset(date)))
            setDialogDate(d)
        } else {
            setDialogTitle(child.fio + '<br/><small>Вступительный взнос</small>')
            setDialogReceipts(rows.receipts.filter((rec) => rec.children_id === child.id && !rec.date))
            setDialogDate(null)
        }
        setDialogVisible(true)
        setDialogChildren(child)
    }


    const paymentForm = useFormik({
        validate: (data) => {
            let errors = {}
            if(data.amount < 1){
                errors.amount = 'Введите сумму'
            }
            if(!data.date){
                errors.date = 'Введите дату'
            }
            if(!data.type){
                errors.type = 'Укажите тип оплаты'
            }
            if(activeAdditional && !data.count_services){
                errors.count_services = 'Укажите кол-во занятий'
            }
            return errors
        },
        initialValues: {
            date: new Date(),
            amount: null,
            comment: '',
            type: 'rub',
            id: null,
            object_type: locationParams.type,
            count_services: null
        },
        onSubmit: (data) => {
            setDialogLoading(true)
            data.object_type = locationParams.type
            data.children_id = dialogChildren.id
            data.created_at = data.date.getTime()/1000

            if(dialogDate) {
                data.date = formater.dateWithOffset(dialogDate)
            } else {
                data.date = null;
            }
            data.department_id = currentDepartment

            if(activeAdditional){
                data.additional_id = activeAdditional
            }



            FinanceService.Update(data).then((result) => {
                setDialogLoading(false)
                setReceiptDialogVisible(false)
                setDialogReceipts(false)
                updateData()
            })
        }
    })
    const isPaymentFormFieldInvalid = (name) => !!(paymentForm.touched[name] && paymentForm.errors[name]);

    const addReceiptHandler = () => {
        setReceiptDialogVisible(true)
        // paymentForm.setFieldValue('id', null)
        paymentForm.resetForm()
    }

    const editPaymentHandler = (row) => {
        console.log(row)
        paymentForm.setValues({
            date: new Date(row.created_at * 1000),
            amount: row.amount,
            comment: row.comment,
            type: row.type,
            id: row.id,
            count_services: row.count_services
        })
        setReceiptDialogVisible(true)
    }

    const deletePaymentHandler = (row) => {

        confirmDialog({
            message: 'Вы хотите удалить этот платеж?',
            header: 'Подтвердите удаление',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: (r) => {
                FinanceService.Delete({id: row.id}).then((r) => {
                    updateData()
                })
            },
            acceptLabel: 'Удалить',
            reject: () => {return false},
            rejectLabel: 'Нет'
        });
    }

    return (
        <div className={'p-b-10'}>

            <ConfirmDialog/>

            <Sidebar position={'left'} className={'receipt-edit'} visible={dialogVisible}
                     onHide={() => setDialogVisible(false)}>

                <div className={'d-flex align-items-center gap-2 m-b-10'}>
                    <Image imageClassName="rounded-circle img-60 "
                           className={'rounded-circle overflow-hidden m-r-10 flex-shrink-0'}
                           alt=""
                           src={'http://yii2.easytickets.pro' + dialogChildren.avatar}
                           preview/>
                    <h2 dangerouslySetInnerHTML={{__html: dialogTitle}}></h2>
                </div>


                {dialogReceipts.length ?
                    <div className={'receipts m-t-20'}>
                        {dialogReceipts.map((row) => {
                            return (
                                <div className={'receipt-item p-3'}>
                                    <time>
                                        <i className={'pi pi-calendar'}></i>
                                        <span>{new Date(row.created_at * 1000).toLocaleDateString()}</span>
                                    </time>
                                    <Tooltip target=".receipt-item__comment" mouseTrack mouseTrackLeft={10}/>
                                    {row.comment && <div className={'receipt-item__comment'}  data-pr-tooltip={row.comment}
                                                         data-pr-position="right"
                                                         data-pr-at="right"
                                                         data-pr-my="left center-2">
                                        <i className={'pi pi-info'}></i>
                                    </div>}
                                    <div className={'receipt-item__type'}>{formater.financeTypeString(row.type)}</div>
                                    <div className={'receipt-item__amount'}>+{formater.amountFormat(row.amount)}</div>



                                    <div className="receipt-item__actions">
                                        <div className={'btn'} onClick={(e) => editPaymentHandler(row)}>
                                            <i className={'pi pi-pencil'}></i>
                                        </div>
                                        <div className={'btn'} onClick={(e) => deletePaymentHandler(row)}>
                                            <i className={'pi pi-trash'}></i>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    : <p className={'text-muted'}>Пока нет платежей</p>}

                <div className={'m-t-20'}>
                    <Button onClick={() => addReceiptHandler()} className={'text-center  justify-center'}
                            icon={'pi pi-plus'} label={'Добавить'} iconPos={'right'}></Button>
                </div>
            </Sidebar>

            <Dialog resizable={false} draggable={false} style={{'width': '28vw'}} header={'Добавить платеж'} position={'top-left'}
                    visible={receiptDialogVisible} onHide={() => setReceiptDialogVisible(false)}>
                <form className={'p-t-15'} onSubmit={paymentForm.handleSubmit}>
                    <div className="row">
                        <div className="col-6">
                            <FormGroup label={'Дата'}  error={paymentForm.errors.date}>
                                <Calendar className={'w-100 ' + classNames({'p-invalid': isPaymentFormFieldInvalid('date')})} value={paymentForm.values.date} dateFormat={'dd.mm.yy'} onChange={(e) => paymentForm.setFieldValue('date', e.target.value)}/>
                            </FormGroup>
                        </div>
                        <div className="col-6">
                            <FormGroup label={'Сумма'} error={paymentForm.errors.amount}>
                                <InputNumber className={'w-100 ' + classNames({'p-invalid': isPaymentFormFieldInvalid('amount')})} maxFractionDigits={0}

                                             mode={'currency'} value={paymentForm.values.amount} onChange={(e) => paymentForm.setFieldValue('amount', e.value)} currency={'RUB'}/>
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup label={'Примечание'}>
                                <InputTextarea className={'w-100'} onChange={(e) => paymentForm.setFieldValue('comment', e.target.value)} value={paymentForm.values.comment} rows={2} autoResize={true}/>
                            </FormGroup>
                        </div>
                        {activeAdditional && <div className={'col-6'}>
                        <FormGroup label={'Кол-во занятий'} eroor={paymentForm.errors.count_services}>
                            <InputNumber value={paymentForm.values.count_services} onChange={(e) => paymentForm.setFieldValue('count_services', e.value)}/>
                        </FormGroup>
                        </div>}
                        <div className={activeAdditional ? "col-6" : "col-12"}>
                            <FormGroup label={'Способ оплаты'} error={paymentForm.errors.type}>
                                <Dropdown optionValue={'value'} className={classNames({'p-invalid': isPaymentFormFieldInvalid('type')})} value={paymentForm.values.type} onChange={(e) => paymentForm.setFieldValue('type', e.target.value)} placeholder={'Способ оплаты'} options={[
                                    {
                                        label: 'Наличные',
                                        value: 'rub'
                                    },
                                    {
                                        label: 'Картой',
                                        value: 'credit'
                                    },
                                ]}/>
                            </FormGroup>
                        </div>
                        <div className="col-12 m-t-20">
                            <Button type={'submit'} label={'Сохранить'} loading={dialogLoading} className={'w-100'}/>
                        </div>
                    </div>


                </form>
            </Dialog>

            <div className="card project-list">
                <div className="row">
                    <div className="col-9 align-items-center justify-content-between">

                        {['additional_class', 'individual_lesson'].includes(locationParams.type) ?
                            <>
                                {additionals && additionals.length ?
                                    <Dropdown placeholder={'Выберите предмет'} options={additionals.map((item) => {
                                        return {value: item.id, label: item.name}
                                    })} value={activeAdditional} onChange={(e) => setActiveAdditional(e.target.value)}/>
                                    : <Message text={<>В филиале нет предметов. <Link to={"/departments/" + currentDepartment + "/additional"}>Добавить</Link></>} severity={'warn'}/>}
                            </> :
                            <ScrollPanel style={{width: '100%', height: '100%'}} className={''}><NavFilter hideAll
                                                                                                           options={navOptions}
                                                                                                           handleClick={(e) => {
                                                                                                               setActiveGroup(e)
                                                                                                           }}
                                                                                                           active={activeGroup}
                            /></ScrollPanel>
                        }


                    </div>
                    <div className="col-3 p-r-0">
                        <div className={'d-flex gap-2 flex-shrink-0 justify-content-end p-button-group'}>
                            <Button icon={'pi pi-angle-left'} text={true} severity="secondary"
                                    onClick={(e) => prevYearHandler()}/>
                            {calendarVisible &&
                                <Calendar ref={calendarRef}
                                          inputClassName={' p-component p-button-secondary p-button p-button-text'}
                                          value={date} onChange={(e) => setDate(e.value)} view="year"
                                          dateFormat={"yy" + '-' + (parseInt(date.getFullYear()) + 1)}/>
                            }
                            <Button icon={'pi pi-angle-right'} text={true} severity={'secondary'}
                                    onClick={(e) => nextYearHandler()}/>
                        </div>
                    </div>
                </div>
            </div>

            {activeAdditional || !['additional_class', 'individual_lesson'].includes(locationParams.type) ?
                <div className="card" style={{'overflow': 'hidden', 'height': 'calc(100vh - 302px)'}}>
                    <div className="table-responsive">

                        {rows && rows.children && rows.children.length ?
                            <table className={'schedule-table schedule-table_finance'}>
                                <thead>
                                <tr>
                                    <th className={'f-12'}>Ребенок</th>
                                    {dates.map((date) => {

                                        const d = formater.dateWithOffset(date)
                                        const d2 = new Date()
                                        d2.setDate(1)
                                        d2.setHours(0, 0, 0, 0)

                                        return (
                                            <th className={' ' + (new Date(d).setHours(0, 0, 0, 0) === d2.getTime() ? 'current' : '')}>
                                                <div
                                                    className={'f-12'}>{Formatter.MonthShortName(date.getMonth())}</div>
                                                <div className={'f-12'}>{date.getFullYear()}</div>

                                                {/*<div className={'f-10 f-w-300 text-end'}>{Formatter.dayShortName(date.getDay())}</div>*/}
                                            </th>
                                        )
                                    })}
                                    {!activeAdditional &&
                                        <th className={'f-12'}>
                                            Вступительный взнос
                                        </th>
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    rows && rows.children.map((child, k) => {
                                        let counter = 0;
                                        let serviceCount = false;
                                        if (activeAdditional && child.service_count) {
                                            let sc = child.service_count.find((sc) => sc.additional_id === activeAdditional)
                                            if (sc) {
                                                serviceCount = sc.count;
                                            }
                                        }
                                        let entranceFee = rows.receipts.filter((el) => !el.date && el.children_id === child.id && el.object_type === locationParams.type).reduce((ac, el) => ac + el.amount, 0)
                                        let balance = false
                                        if(locationParams.type === 'kindergarten' || locationParams.type === 'summer_camp' || locationParams.type === 'school'){
                                            balance = child.balance[locationParams.type]
                                        }

                                        return (
                                            <tr>
                                                <th>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className={'list-number'}>{k + 1}.</span>


                                                        <div className={'d-flex align-items-center w-100'}>
                                                            <Image imageClassName="rounded-circle img-40 "
                                                                   className={'rounded-circle overflow-hidden m-r-10 flex-shrink-0'}
                                                                   alt=""
                                                                   src={'http://yii2.easytickets.pro' + child.avatar}
                                                                   preview/>

                                                            <Link className={'w-100'}
                                                                  to={'/client/' + child.object.id}>{child.fio}</Link>


                                                            {serviceCount !== false && <Badge
                                                                className={'badge m-l-10 ' + (serviceCount >= 0 ? 'badge-success' : 'badge-danger')}
                                                                value={serviceCount}></Badge>}
                                                        </div>

                                                        {balance &&
                                                        <>
                                                            <Badge
                                                                className={'badge m-l-10 ' + (balance >= 0 ? 'badge-success' : 'badge-danger')} style={{'flex-shrink': 0}}
                                                                value={formater.amountFormat(balance)}></Badge>
                                                        </>
                                                        }

                                                    </div>
                                                </th>
                                                {dates.map((date) => {
                                                    const d = formater.dateWithOffset(date)
                                                    const at = rows.receipts.filter((el) => el.date === d && el.children_id === child.id && el.object_type === locationParams.type)
                                                    let rowSumm = 0
                                                    let receiptCounter = 0;
                                                    if (at.length) {
                                                        at.map((el) => {
                                                            rowSumm += el.amount
                                                            if (el.amount > 0) {
                                                                receiptCounter++
                                                            }
                                                        })
                                                    }
                                                    return (
                                                        <td onClick={(e) => editPaymentsHandler(child, date)}
                                                            className={(getClasses(child.contracts.filter((contract) => contract.type === locationParams.type && ((activeGroup && contract.group_id === activeGroup) || (activeAdditional && activeAdditional === contract.additional_id))), d))}>
                                                            <div>{rowSumm > 0 ? formater.amountFormat(rowSumm) : ''}</div>
                                                            {receiptCounter > 0 ?
                                                                <div className={'text-muted fs-10'}>
                                                                    платежей: {receiptCounter}
                                                                </div>
                                                                : ''}

                                                            <div className="hover-icon">
                                                                <i className="pi pi-plus"></i>
                                                            </div>

                                                        </td>
                                                    )
                                                })}
                                                {!activeAdditional &&
                                                    <td onClick={(e) => editPaymentsHandler(child, null)}>
                                                        {entranceFee && formater.amountFormat(entranceFee)}

                                                        <div className="hover-icon">
                                                            <i className="pi pi-plus"></i>
                                                        </div>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    })}


                                <tr>
                                    <th>
                                        <strong>Итого по группе:</strong>
                                    </th>
                                    {dates.map((date) => {
                                        const d = formater.dateWithOffset(date)
                                        let groupSumm = 0
                                        rows.receipts.filter((el) => el.date === d).map((el) => {
                                            groupSumm += el.amount
                                        })
                                        return (
                                            <td>
                                                <strong>{formater.amountFormat(groupSumm)}</strong>
                                            </td>
                                        )
                                    })}
                                </tr>

                                {!isLoaded && <Loader/>}

                                </tbody>
                            </table>
                            : <div className={'p-3'}><Message text={'Нет контрактов в выбранный период.'}
                                                              severity={'warn'}/></div>}


                    </div>
                </div>
                : ''}
        </div>
    )
}